import { isEmpty } from 'lodash';
import * as actionType from './actionTypes';

const initialState = [];

const duplicateVehicleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.ADD_DUPE_VEHICLE: {
      const existingVehicle = state.filter(
        item => item.vin === action.payload.vin
          && item.dealerNumber === action.payload.dealerNumber
      );
      const newStateArray = state.slice();
      if (isEmpty(existingVehicle)) {
        newStateArray.splice(state.length, 0, action.payload);
      }
      return newStateArray;
    }

    case actionType.REMOVE_DUPE_VEHICLE: {
      const newStateArray = state.filter(
        item => !(
          item.vin === action.payload.vin
            && item.dealerNumber === action.payload.dealerNumber
        )
      );
      return newStateArray;
    }
    case actionType.CLEAR_DUPE_VEHICLE:
      return [];
    default:
      return state;
  }
};

export default duplicateVehicleReducer;
